export const CheckedSquareIcon = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='1.88892' y='1.88892' width='30.2222' height='30.2222' rx='4' fill='currentColor' />
    <path
      d='M10.3889 17.4723L14.1667 22.6667L23.6111 12.2778'
      stroke='currentColor'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
